import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "template", "input"];

  connect() {
    this.optValue = this.inputTarget.value;
  }

  updateOptValue(e) {
    this.optValue = e.target.value;
  }

  applyChange(e) {
    if(e.target.checked) {
      const content = this.templateTarget.innerHTML.replace(/CORRECT_VALUE/g, this.optValue);
      this.wrapperTarget.innerHTML = content;
    } else {
      this.wrapperTarget.innerHTML = "";
    }
  }
}
